import { Box, TypographyProps, useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";

const Heading = (
  props: TypographyProps & {
    variant: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  },
) => {
  const theme = useTheme();

  if (theme.name === "inline") {
    return (
      <Box
        {...props}
        component={props.component || (props as any).as || props.variant}
      />
    );
  }

  return <Typography {...props} />;
};

export default Heading;
